/**
 * KpiGrid — Standard KPI card grid.
 * Renders N cards in a responsive grid with consistent styling.
 */
import React from 'react';

interface KpiItem {
  label: string;
  value: string | number;
  color?: string;
  subtitle?: string;
  onClick?: () => void;
}

interface KpiGridProps {
  items: KpiItem[];
  columns?: number;
}

export default function KpiGrid({ items, columns }: KpiGridProps) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: columns ? `repeat(${columns}, 1fr)` : 'repeat(auto-fill, minmax(200px, 1fr))',
      gap: 12,
      marginBottom: 20,
    }}>
      {items.map((item, i) => (
        <div
          key={i}
          onClick={item.onClick}
          style={{
            padding: '16px 20px',
            borderRadius: 8,
            border: '1px solid var(--border-subtle)',
            background: 'var(--bg-card)',
            cursor: item.onClick ? 'pointer' : 'default',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => { if (item.onClick) e.currentTarget.style.borderColor = 'var(--border-hover)'; }}
          onMouseLeave={e => { if (item.onClick) e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
        >
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-hint)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6 }}>
            {item.label}
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: item.color || 'var(--text-primary)', fontVariantNumeric: 'tabular-nums', lineHeight: 1.2 }}>
            {item.value}
          </div>
          {item.subtitle && (
            <div style={{ fontSize: 11, color: 'var(--text-hint)', marginTop: 4 }}>
              {item.subtitle}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
